import * as THREE from 'three'
import { OrderEditorCutoutTypes, OrderEditorGeometryShapeTypes } from '@/store/types'

/**
 * Radius Cut class
 * Used internally when calculating radius cuts in a glass shape and converting to OrderItems
 */
export default class RadiusCut {
  constructor(cutData = {}) {
    this.segmentId = cutData.segmentId || []
    this.radius = cutData.radius || 0
    this.isPolished = cutData.isPolished || false
    this.bounds = cutData.bounds || new THREE.Box2()
  }


  /**
   * Generate a description for the OrderItem based on the radius cut details
   * 
   * @param {Object} cutoutStockInfo - The object for the OrderEditorCutoutStock record from the server that matches the radius cut
   * @param {Object} stockItem - The Stock
   * @return {String} Returns the description of the radius cut
   */
  generateDescription(cutoutStockInfo, stockItem) {
    var description = cutoutStockInfo.description || ''
    if(description.trim() == '')
      description = stockItem.name

    let radius = Math.round(parseFloat(this.radius || 0))

    // Add radius
    description += ` ${radius.toFixed(0)}mm`

    return description
  }

}